<template>
  <div class="el-select-dropdown el-popper"
    style="min-width:92%;max-width:92%;transform-origin: center top;z-index: 2022;position: absolute;margin-top: 32px;"
    x-placement="bottom-start"> 
    <div class="el-scrollbar" 
      v-show=" dataList.length>0 && !loading">
      <div class="el-select-dropdown__wrap el-scrollbar__wrap el-scrollbar__wrap--hidden-default" style="max-height: 170px;">
        <ul class="el-scrollbar__view el-select-dropdown__list">
          <li class="el-select-dropdown__item"
            v-for="item in dataList"
            :key="item.index"
            @click="itemClick(item)">
            {{ item.name}} </li>
        </ul>
      </div>
      <div class="el-scrollbar__bar is-horizontal">
        <div class="el-scrollbar__thumb"
          style="transform: translateX(0%);"></div>
      </div>
      <div class="el-scrollbar__bar is-vertical">
        <div class="el-scrollbar__thumb"
          style="transform: translateY(0%); height: 64.0187%;"></div>
      </div>
    </div> 

    <p class="el-select-dropdown__empty"
      v-show="dataList.length==0 || loading">
      {{ loading ? "正在加载": (dataList.length== 0 ?"无数据" : "")}}
    </p>

    <div x-arrow=""
      class="popper__arrow"
      style="left: 35px;"></div>
  </div>
</template>

<script>
export default {
  name: "SelectPanel",
  props: {
    componentName: {
      type: String,
      default: "",
    },
    dataList: {
      type: Array,
      default: [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {};
  },
  components: {},
  mounted () { },
  methods: {
    itemClick (item) {
      this.$emit("itemClick", item, this.componentName);
    }
  },
};
</script>

<style >
</style>


// WEBPACK FOOTER //
// src/components/common/SelectPanel.vue